// angular
// 	.module("HeroPRO")
// 	.controller("HISWizardController", hisWizardController);

import angular from 'angular';

import _ from 'lodash';
import './hisWizard.scss';

const HISWizardStages = {
    Intro: 0,
    HISStatusPrompt: 1,
    HISLicenseLookup: 2,
    PhoneNumberVerification: 3,
    RedirectToTLMS: 4,
    Error: 5,
    IsExpiring: 6,
    IsExpired: 7,
    IsSuspended: 8
};

/* @ngInject */
export default function hisWizardController(UserData, HISWizardFactory, AccountsFactory, $rootScope, $uibModalInstance, TopNavFactory, authenticationService, UserAuthFactory, HPConfig, $analytics, PartnerAppsFactory, $window, UiDisplayFactory, PermissionsFactory) {
    const vm = this;

    vm.stage = HISWizardStages.Intro;
    vm.stageHistory = [];
    vm.canDismissModal = false;
    vm.hisExempt = null;
    vm.checkboxClicked = false;
    vm.hisNumber = '';
    vm.loading = false;
    vm.hisErrorMsg = '';
    vm.hisLicenseName = '';
    vm.phoneNumber = '';
    vm.email = '';
    vm.redirectUrl = '';
    vm.daysLeftToComplete = 0;
    vm.isBenjiUser = UiDisplayFactory.getDisplayRules().isBenjiUser;
    vm.isSolicitor = PermissionsFactory.hasPermission('IsSolicitor');
    vm.isAdvertiser = PermissionsFactory.hasPermission('IsAdvertiser');

    init();

    /*= =======================================
       =            Public Functions            =
       ======================================== */
    vm.closeModal = closeModal;
    vm.logout = logout;
    vm.validateHIS = validateHIS;
    vm.saveAndContinue = saveAndContinue;
    vm.savePhoneNumber = savePhoneNumber;
    vm.validatePhoneNumber = validatePhoneNumber;
    vm.setExemptionStatus = setExemptionStatus;
    vm.back = back;
    vm.getStarted = getStarted;
    vm.gotoBenji = gotoBenji;
    vm.gotoStage = gotoStage;

    function back() {

        if(vm.stageHistory.length > 0)
        {
            vm.stage = vm.stageHistory.pop();
        }

        /*
        if(vm.stage == HISWizardStages.HISLicenseLookup)
        {
            vm.stage = HISWizardStages.Intro;
            vm.prevStage = 0;
        }
        else
        {
            vm.stage = vm.prevStage;


            vm.stage--;
            if (vm.stage == HISWizardStages.HISLicenseLookup) vm.stage--;
            vm.stage = Math.max(0, vm.stage);            
        }
        */
    }

    function gotoBenji() {
        $window.open(PartnerAppsFactory.getBenjiLink(), '_blank');
    }

    function gotoStage(stageId) {
        vm.stageHistory.push(vm.stage);
        vm.stage = stageId;
    }

    function validateHIS() {
        if (vm.loading) return;

        vm.checkboxClicked = false;
        vm.loading = true;
        $rootScope.$broadcast('ShowMainSpinner');

        vm.hisErrorMsg = '';
        vm.hisLicenseName = '';

        HISWizardFactory.validateHISNumber(vm.hisNumber).then((data) => {
            console.log(data);
            if (data.Error) {
                vm.hisErrorMsg = data.Error;
            } else {
                vm.hisErrorMsg = '';
                vm.hisLicenseName = `${data.Metadata.FirstName} ${data.Metadata.LastName}`;
            }
            vm.loading = false;
            $rootScope.$broadcast('HideMainSpinner');
        }, handleError);
    }

    function setExemptionStatus() {
        if (vm.hisExempt) {
            saveAndContinue();
        } else {
            vm.gotoStage(HISWizardStages.HISLicenseLookup);
        }
    }

    function getStarted() {
        if (!vm.IsDesignationRequired) {
            if (vm.IsLicenseEntryRequired) {
                vm.gotoStage(HISWizardStages.HISLicenseLookup);
            } else if (vm.IsContactInfoRequired) {
                vm.gotoStage(HISWizardStages.PhoneNumberVerification);
            }
            else {
                vm.gotoStage(HISWizardStages.RedirectToTLMS);
                _redirectToTraining();
            }
        } else {
            vm.gotoStage(HISWizardStages.HISStatusPrompt);
        }
    }

    function savePhoneNumber() {
        if (vm.loading) return;

        vm.loading = true;
        $rootScope.$broadcast('ShowMainSpinner');

        AccountsFactory.confirmContractorUserContactInfo({
            PhoneNumber: vm.phoneNumber,
            Email: vm.email,
        }).then(() => {
            vm.gotoStage(HISWizardStages.RedirectToTLMS);
            UserData.getHISTrainingMandate().then((mandate) => {
                if (mandate.IsTrainingRequired) {
                    _redirectToTraining();
                } else {
                    $uibModalInstance.close();
                    window.location.reload();
                }
            }, handleError);
        }, handleError);
    }

    function validatePhoneNumber() {
        return !!vm.phoneNumber && vm.phoneNumber.length >= 9;
    }

    function saveAndContinue() {
        if (vm.loading) return;

        vm.loading = true;
        $rootScope.$broadcast('ShowMainSpinner');

        AccountsFactory.setHISLicenseExemptionStatus({
            IsHISExempt: vm.hisExempt,
            LicenseNumber: vm.hisNumber,
        })
            .then(() => {
                vm.gotoStage(HISWizardStages.PhoneNumberVerification);
                vm.loading = false;
                $rootScope.$broadcast('HideMainSpinner');
            }, handleError);
    }

    function closeModal() {
        $uibModalInstance.close();
    }

    function logout() {
        /*
         * THIS CODE IS A DUPLICATION OF
         * TopNavController#logout()
         *
         * TODO: Move this into a central location
         */
        $analytics.eventTrack('Logout', {
            category: 'TopNav',
            label: 'HISWizard',
        });

        TopNavFactory.logout().then(() => {
            // (ajt 3/23/16) PBI 414 Implement IDV validation
            authenticationService.logOut();

            UserAuthFactory.deleteAuthorization();

            let logoutUrl = HPConfig.heroProLoginLink;

            logoutUrl += '?logout=true';

            $window.location.href = logoutUrl;
        });
    }
    /* -----  End of Public Functions  ------*/


    /*= ========================================
       =            Private Functions            =
       ========================================= */
    function init() {
        $rootScope.$broadcast('ShowMainSpinner');
        vm.loading = true;
        UserData.getHISTrainingMandate().then((mandate) => {
            const today = new Date();
            const gpExpire = mandate.TrainingRequiredBy;
            vm.IsContactInfoRequired = mandate.IsContactInfoRequired;
            vm.IsDesignationRequired = mandate.IsDesignationRequired;
            vm.IsLicenseEntryRequired = mandate.IsLicenseEntryRequired;
            vm.IsTrainingRequired = mandate.IsTrainingRequired;
            vm.IsLicenseExpiring = mandate.IsLicenseExpiring;
            vm.IsLicenseExpired = mandate.IsLicenseExpired;
            vm.IsLicenseSuspended = mandate.IsLicenseSuspended;

            vm.daysLeftToComplete = UserData.getTrainingDaysRemaining(gpExpire);
            vm.canDismissModal = vm.daysLeftToComplete > 1;

            if (!vm.IsDesignationRequired) {
                if (mandate.PersonIdentityLicenseTypeId == 3) {
                    vm.hisExempt = true;
                } else {
                    vm.hisExempt = false;
                }
            }

            if(vm.IsLicenseExpiring) {
                vm.stage = HISWizardStages.IsExpiring;
                vm.canDismissModal = true;
            } else if(vm.IsLicenseExpired) {
                vm.stage = HISWizardStages.IsExpired;
                vm.canDismissModal = false;
            } else if(vm.IsLicenseSuspended) {
                vm.stage = HISWizardStages.IsSuspended;
                vm.canDismissModal = false;
            } else {
                 vm.stage = HISWizardStages.Intro;
            }

            vm.loading = false;
            $rootScope.$broadcast('HideMainSpinner');
        }, handleError);
    }

    function handleError() {
        $rootScope.$broadcast('HideMainSpinner');
        vm.stage = HISWizardStages.Error;
    }

    function _redirectToTraining() {
        return HISWizardFactory
            .getHISTrainingRedirectURI()
            .then((response) => {
                $rootScope.$broadcast('HideMainSpinner');
                vm.loading = false;
                const redirectUrl = response.Data.RedirectURI;
                vm.redirectUrl = redirectUrl;
                window.open(redirectUrl, '_blank');
            }, handleError);
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/hisWizard/hisWizardController.js